module.exports = __webpack_public_path__ + "resources/icon_94_xiajia.986bffc4e5c6764a.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-manage/manage-dialog/img/icon_94_xiajia.png
// module id = 614
// module chunks = 0 1 2 3